export default __webpack_public_path__ + "static/media/img-0028.53c82650.png";